import NoteAndDocument from "../../../../../../components/noteAndDocument/NoteAndDocument";
import { InternalStorageNotesSectionProps } from "../internalStorage.types";

const InternalStorageNotesSection = ({
  notesRef,
  parentId,
  disabled
}: InternalStorageNotesSectionProps) => (
  <NoteAndDocument
    parentId={parentId}
    ref={notesRef}
    isDisabled={disabled}
    showSaveButton={false}
  />
);

export default InternalStorageNotesSection;
